import React from "react"

const Footer =()=>{

    return (
        <>
         <div class=" top-10 right-20 animate-float bg-cover w-100vw h-auto" style={{backgroundImage: "url('https://img.freepik.com/premium-photo/cyberpunk-forest-futuristic-neon-forest-generative-ai-technology_899928-5.jpg')"}}>
         <footer class="text-gray-600 body-font ">
  <div class="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col">
    <a class="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
    <img src="https://prompti.ai/wp-content/uploads/2023/07/pcboi2.png" class="flex m-auto border rounded-full w-12 h-12" />

      <span class="ml-3 text-xl text-white">Mahendra Singh</span>
    </a>
    <p class="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4 text-white">© Mahi Singh 
      <a href="https://www.linkedin.com/in/mahendra-singh-995063249/" class="text-gray-600 ml-1 text-white" rel="noopener noreferrer" target="_blank">(Nit Allahabad)</a>
    </p>
    <span class="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
      <a class="text-gray-500 text-white-500" href="https://www.facebook.com/profile.php?id=100076181456548">
        <svg fill="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
          <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
        </svg>
      </a>
      <a class="ml-3 text-gray-500 text-white-500" href="https://x.com/Mahendr49416759">
        <svg fill="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
          <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
        </svg>
      </a>
      <a class="ml-3 text-gray-500 text-white-500" href="https://www.instagram.com/mahendra_singh2001/">
        <svg fill="white" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-5 h-5" viewBox="0 0 24 24">
          <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
          <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
        </svg>
      </a>
      <a class="ml-3 text-gray-500 text-white-500" href="https://www.linkedin.com/in/mahendra-singh-995063249/">
        <svg fill="white" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="0" class="w-5 h-5" viewBox="0 0 24 24">
          <path stroke="none" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path>
          <circle cx="4" cy="4" r="2" stroke="none"></circle>
        </svg>
      </a>
    </span>
  </div>
</footer>
</div>
        </>
    )
}

export default Footer;